import { render } from "./DesktopMenuBar.vue?vue&type=template&id=0cf744a2&scoped=true"
import script from "./DesktopMenuBar.vue?vue&type=script&lang=js"
export * from "./DesktopMenuBar.vue?vue&type=script&lang=js"

import "./DesktopMenuBar.vue?vue&type=style&index=0&id=0cf744a2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf744a2"]])

export default __exports__